import React from "react";

const Check: React.FC = () => (
  <svg width="10" height="10" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60863 0.641432C9.85271 0.88551 9.85271 1.28124 9.60863 1.52532L3.7753 7.35865C3.65143 7.48252 3.48127 7.54872 3.30626 7.54112C3.13125 7.53353 2.96746 7.45284 2.85479 7.3187L0.354792 4.34251C0.132777 4.07821 0.167058 3.68397 0.431363 3.46195C0.695667 3.23994 1.08991 3.27422 1.31192 3.53852L3.37346 5.99273L8.72475 0.641432C8.96883 0.397355 9.36456 0.397355 9.60863 0.641432Z"
      fill="white"
    />
  </svg>
);

export default Check;
